import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/app-2.png'


const _hoisted_1 = {
  class: "for-dark rounded-3 p-4 text-center mb-4",
  style: {"background":"linear-gradient(153deg, #fad2d2 0%, #6fa3ec 100%)"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<div class=\"py-2\"><h3 class=\"fs-20 fw-normal\">Have You Tried Our</h3><h3 class=\"fs-20 mb-1\">New Mobile App?</h3><div class=\"py-5\"><img src=\"" + _imports_0 + "\" alt=\"app\"></div><a href=\"#\" class=\"btn btn-primary py-2 px-3 fs-16 fw-medium\"> Download App </a></div>", 1)
  ])))
}